import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { Box } from '@mui/material';
// components
import { useTheme } from '@mui/material/styles';
import { FOOTER } from '@raas/shared/src/shared-config-global';
import { useSettingsContext } from '@raas/shared/src/components/minimals/settings';
// hooks
import useResponsive from '@raas/shared/src/hooks/useResponsive';
//
import Header from '@raas/shared/src/components/header';
import Main from './Main';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import Footer from './Footer';

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { themeLayout } = useSettingsContext();

  const theme = useTheme();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const renderNavigation = () => {
    switch (themeLayout) {
      case 'horizontal':
        return isDesktop ? (
          <NavHorizontal />
        ) : (
          <NavVertical openNav={open} onCloseNav={handleClose} />
        );
      case 'mini':
        return isDesktop ? <NavMini /> : <NavVertical openNav={open} onCloseNav={handleClose} />;
      default:
        return <NavVertical openNav={open} onCloseNav={handleClose} />;
    }
  };
  return (
    <>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
        }}
      >
        {renderNavigation()}

        <Main
          sx={{
            backgroundColor: theme.palette.background.neutral,
            minHeight: {
              lg: `calc(100vh - ${FOOTER.H_MAIN_DESKTOP + 12}px)`,
              marginTop: '12px',
            },
          }}
        >
          <Outlet />
        </Main>
      </Box>
      <Footer />
    </>
  );
}
